import { NgIf } from '@angular/common';
import { Component, ViewEncapsulation, Input, OnInit } from '@angular/core';
import { BankDetailModel } from '@App/common/models';

@Component({
  selector: 'app-bank-account-thumbnail',
  templateUrl: './bank-account-thumbnail.component.html',
  imports: [NgIf],
  standalone: true,
  styleUrls: ['./bank-account-thumbnail.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BankAccountThumbnailComponent implements OnInit {
  @Input() model: BankDetailModel;

  constructor() {}

  get routingNumber() {
    return (
      'X'.repeat(this.model.routingNumber.length - 4) +
      this.model.routingNumber.substr(this.model.routingNumber.length - 4, 4)
    );
  }

  get accountNumber() {
    return (
      'X'.repeat(this.model.accountNumber.length - 4) +
      this.model.accountNumber.substr(this.model.accountNumber.length - 4, 4)
    );
  }

  get accountType() {
    return this.model.accountHolderType == 'checking' ? 'Checking' : 'Saving';
  }

  ngOnInit(): void {}
}
